import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pending-page',
  templateUrl: './pending-page.component.html',
  styleUrls: ['./pending-page.component.scss']
})
export class PendingPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
